import { render, staticRenderFns } from "./ChangeDetail.vue?vue&type=template&id=98ecf6c0&scoped=true&"
import script from "./ChangeDetail.vue?vue&type=script&lang=js&"
export * from "./ChangeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChangeDetail.vue?vue&type=style&index=0&id=98ecf6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ecf6c0",
  null
  
)

export default component.exports